export enum TagVariant {
  subtle = 'subtle',
  solid = 'solid',
  outline = 'outline',
}

export enum TagSize {
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
}
